import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import { testClass } from 'omni-common-ui';
import StudentReportSummary from 'data/ProgressReports/StudentReportSummaries/model';
import PropTypes from 'prop-types';

const STATUS_MISSING = StudentReportSummary.Status.ScoresMissing.toLowerCase();
const STATUS_READY = StudentReportSummary.Status.Ready.toLowerCase();
const STATUS_SENT_TO_DOS = StudentReportSummary.Status.SentToDoS.toLowerCase();
const STATUS_COMPLETED = StudentReportSummary.Status.Completed.toLowerCase();
const STATUS_PUBLISHED = StudentReportSummary.Status.Published.toLowerCase();
const STATUS_REJECTED = StudentReportSummary.Status.Rejected.toLowerCase();

const ProgressReportStatus = (props) => {
  const { status, className } = props;

  const lowercaseStatus = status.toLowerCase();

  const containerClasses = classnames(
    styles.ProgressReportStatus,
    className,
    testClass('progress-report-status')
  );
  const statusClasses = classnames(styles.ProgressReportStatus_inner, {
    [styles.__ready]: lowercaseStatus === STATUS_READY,
    [styles.__sent]: lowercaseStatus === STATUS_SENT_TO_DOS,
    [styles.__published]: lowercaseStatus === STATUS_COMPLETED ||
        lowercaseStatus === STATUS_PUBLISHED,
    [styles.__missing]: lowercaseStatus === STATUS_MISSING,
    [styles.__rejected]: lowercaseStatus === STATUS_REJECTED,
  });

  let statusToDisplay;
  switch (lowercaseStatus) {
    case STATUS_MISSING:
      statusToDisplay = 'Scores Missing';
      break;
    case STATUS_SENT_TO_DOS:
      statusToDisplay = 'Sent to DoS';
      break;
    default:
      statusToDisplay = status;
  }

  return <div className={containerClasses}>
    <div className={statusClasses}>{statusToDisplay}</div>
  </div>;
};

ProgressReportStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
};

export default ProgressReportStatus;



// WEBPACK FOOTER //
// ./components/ProgressReportStatus/index.jsx